import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

export const PanelStatusChanged = createAction('[Bulk Operations: History]: Panel Status Changed');

export const GetStatusValues = createAction(
  '[Bulk Operations: History]: Get Status Values',
  props<{ statusValues: string[] }>(),
);

export const ConfigurationNameChanged = createAction(
  '[Bulk Operations: History]: Configuration Name Changed',
  props<{ configurationName: string }>(),
);

export const StatusChanged = createAction('[Bulk Operations: History]: Status Changed', props<{ status: string }>());

export const ImportDateFromChanged = createAction(
  '[Bulk Operations: History]: Import Date From Changed',
  props<{ importDateFrom: Date; importDateFromFormat: string }>(),
);

export const ImportDateFromCleared = createAction('[Bulk Operations: History]: Import Date From Cleared');

export const ImportDateUntilChanged = createAction(
  '[Bulk Operations: History]: Import Date Until Options',
  props<{ importDateUntil: Date; importDateUntilFormat: string }>(),
);

export const ImportDateUntilCleared = createAction('[Bulk Operations: History]: Import Date Until Cleared');

export const ClearBulkHistoryOptions = createAction('[Bulk Operations: History]: Clear Bulk History Options');

export const HistorySearchCount = createAction('[Bulk Operations: History]: History Search Count');

export const HistorySearchCountFailed = createAction(
  '[Bulk Operations: History]: History Search Count Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const OpenErrorsSidenav = createAction('[Bulk Operations: History]: Open Errors Sidenav');
